export default "__VITE_ASSET__DoBk3VG1__"